import { render, staticRenderFns } from "./viewAdmin.vue?vue&type=template&id=75997bfb&"
import script from "./viewAdmin.vue?vue&type=script&lang=js&"
export * from "./viewAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports